import React from 'react';
import ReactDOM from 'react-dom/client';
import { createStore } from 'polotno/model/store';
import {
  setGoogleFonts,
  addGlobalFont,
  unstable_setRemoveBackgroundEnabled,
} from 'polotno/config';

import { createStaticElements } from './static-elements';

import './index.css';
import App from './App';

setGoogleFonts([]);
addGlobalFont({
  fontFamily: 'Gotham A',
});

const store = createStore({ key: 'DEsXVLp6X-Xdu4QX5mip' });
window.store = store;

// disable "remove background" feature
// do it in timeout to wait for license check
setTimeout(() => {
  unstable_setRemoveBackgroundEnabled(false);
}, 5000);

store.setSize(1920, 1080);
store.addPage();

createStaticElements(store);

const minY = 110;
store.on('change', () => {
  store.pages.forEach((page) => {
    page.children.forEach((el) => {
      if (!el.selectable) {
        return;
      }
      if (el.y < minY) {
        el.y = minY + Math.random();
      }
    });
  });
});

window.createEditor = (element) => {
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <App store={store} />
    </React.StrictMode>
  );
};

createEditor(document.getElementById('root'));
